import UNAM from '../../../assets/signatire_karina.png';
import PropTypes from 'prop-types';
import Logos from "./logos-certificate.png";
import {useEffect, useState} from "react";
import Fondo from "./fondo.svg"

export const CertificateLetterComponent = ({ abstract }) => {
    const [authorsString, setAuthorString] = useState('');

    useEffect(() => {
        let tempAuthorString = '';

        if (abstract === undefined) {
            return;
        }

        for (const author of abstract.authors) {
            // Add ", " to tempAuthorString if is not the first author
            if (tempAuthorString.length > 0) {
                tempAuthorString += ', ';
            }
            if (author.name === undefined) {
                continue;
            }
            tempAuthorString += `${author.lastName} ${
                author.name.length > 0 ? author.name[0] + '.' : ''
            }`;
        }
        setAuthorString(tempAuthorString);
    }, [abstract]);

  const Print = () => {
    //console.log('print');
    let printContents = document.getElementById('printablediv').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  useEffect(() => {
    let tempAuthorString = '';

    if (abstract === undefined) {
      return;
    }

    for (const author of abstract.authors) {
      // Add ", " to tempAuthorString if is not the first author
      if (tempAuthorString.length > 0) {
        tempAuthorString += ', ';
      }
      if (author.name === undefined) {
        continue;
      }
      tempAuthorString += `${author.lastName} ${
          author.name.length > 0 ? author.name[0] + '.' : ''
      }`;
    }

  }, [abstract]);

  return (
    <>
      <button className="print-button" onClick={Print}>
        <span className="material-symbols-outlined">print</span> Print
      </button>
      <div id="printablediv" className="acceptance-letter-wrapper">
        <div className="certificate-letter-logos-wrapper">
          <img src={Logos} alt="Proceeding logos" />
        </div>
        <h1 className="certificate-letter-title">ENERGY STORAGE DISCUSSIONS 2025<br/>
            NOVEMBER 19–21<br/>
            ENSENADA, MEXICO </h1>
          <h2 className="certificate-letter-subtitle">CERTIFICATE</h2>
        <div className="acceptance-letter-text-wrapper">
          <p className="acceptance-letter-participants">
            <strong>
                {authorsString}
            </strong>
          </p>
          <p>
              For their participation in Energy Storage Discussions 2025 and their  {abstract.accepted} contribution entitled:
          </p>
          <p className="acceptance-letter-participants">
            <strong>
              “{abstract.title}.”
            </strong>
          </p>
            <p className="certificate-letter-signature">
                Dr. Ana Karina Cuentas Gallegos <br/>
                Conference Chair <br/>
                Mexican Energy Storage Network <br/>
            </p>
          <img className="certificate-signature" src={UNAM} alt="UNAM" />
            <img className="background-image" src={Fondo} alt="Fondo" />
        </div>
      </div>
    </>
  );
};

CertificateLetterComponent.propTypes = {
  abstract: PropTypes.any.isRequired,
};
